import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IApiResult } from '../shared/models/api-result';
import { ApiUrlProvider } from './api-url.provider';
import { IEmployer, IEmployerViewModel } from '../shared/models/employer';


@Injectable({
  providedIn: 'root'
})
export class EmployerService {
  constructor(private http: HttpClient, private apiUrlProvider: ApiUrlProvider) { }
  
  getAll(): Observable<IApiResult<IEmployerViewModel[]>>{
    return this.http.get<IApiResult<IEmployerViewModel[]>>(`${this.apiUrlProvider.url}/employer`);
  }

  add(entity: IEmployer): Observable<IApiResult<IEmployerViewModel>>{
    return this.http.post<IApiResult<IEmployerViewModel>>(`${this.apiUrlProvider.url}/employer`, entity);
  }

  update(entity: IEmployer): Observable<IApiResult<IEmployerViewModel>>{
    return this.http.post<IApiResult<IEmployerViewModel>>(`${this.apiUrlProvider.url}/employer/${entity.id}`, entity);
  }
}
